module.exports = __webpack_public_path__ + "img/ic24ViewOn.be8a92a1.svg";